import React, { useEffect, useState } from 'react';
import API from '../../pages/Api';
import { toast } from 'react-toastify';
import { FaPlus, FaTrash, FaEdit } from 'react-icons/fa';
import TableContainer from '../common/Tablecontainer';

const UpcomingEvents = () => {
    const [events, setEvents] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        eventid: null, eventname: '', fromdate: '', todate: '', frmtime: '', totime: '', venue: '', fees: '', descrption: ''
    });
    const [searchQuery, setSearchQuery] = useState('');

    const [list, setList] = useState([]);
    const [loadingCards, setLoadingCards] = useState(false);

    const [mobilePage, setMobilePage] = useState(1);
    const [mobileTotalPages, setMobileTotalPages] = useState(1);

    const [isMobile, setIsMobile] = useState(
        window.innerWidth < 768
    );
    useEffect(() => {

        const resize = () => {

            setIsMobile(window.innerWidth < 768);

        };

        window.addEventListener("resize", resize);

        return () =>
            window.removeEventListener("resize", resize);

    }, []);
    useEffect(() => { fetchEvents(); }, []);

    const fetchEvents = async () => {
        setLoading(true);
        try {
            const res = await API.get('events/');
            setEvents(res.data);
        } catch (err) {
            console.error("Error fetching events:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        try {
            if (formData.eventid) {
                // Edit / Update
                await API.put(`events/update/${formData.eventid}/`, formData);
                toast.success("Event updated successfully!");
            } else {
                // Add
                await API.post('events/add/', formData);
                toast.success("Event saved successfully!");
            }
            setIsModalOpen(false);
            setFormData({ eventid: null, eventname: '', fromdate: '', todate: '', frmtime: '', totime: '', venue: '', fees: '', descrption: '' });
            fetchEvents();
        } catch (err) {
            toast.error("Operation failed!");
        }
    };

    const handleEdit = (event) => {
        setFormData(event);
        setIsModalOpen(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this event?")) return;
        try {
            await API.delete(`events/delete/${id}/`);
            toast.success("Event deleted!");
            fetchEvents();
        } catch (err) {
            toast.error("Delete failed!");
        }
    };

    const filteredEvents = events.filter(e => e.eventname?.toLowerCase().includes(searchQuery.toLowerCase()));

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        return `${d.getDate().toString().padStart(2, '0')}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getFullYear()}`;
    };
    const loadEvents = async (
        page = mobilePage,
        search = searchQuery
    ) => {

        try {

            setLoadingCards(true);

            const token = localStorage.getItem("access_token");

            const res = await API.get(
                "events/",
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    params: {
                        page,
                        search
                    }
                }
            );

            const data = Array.isArray(res.data)
                ? res.data
                : (res.data.results || []);

            setList(data);

            setMobileTotalPages(
                res.data.count
                    ? Math.ceil(res.data.count / 10)
                    : 1
            );

        } catch (err) {

            console.log(err);

        } finally {

            setLoadingCards(false);

        }

    };
    useEffect(() => {

        if (!isMobile) return;

        loadEvents(1, searchQuery);

    }, []);

    useEffect(() => {

        if (!isMobile) return;

        const timer = setTimeout(() => {

            setMobilePage(1);

            loadEvents(
                1,
                searchQuery
            );

        }, 400);

        return () => clearTimeout(timer);

    }, [searchQuery]);

    useEffect(() => {

        if (!isMobile) return;

        loadEvents(
            mobilePage,
            searchQuery
        );

    }, [mobilePage]);

    return (
        <div className="p-6 bg-[#F8FAFC] min-h-screen w-full flex flex-col items-center font-sans">
            <div className="w-full max-w-8xl mx-auto">
                <h2 className="text-center text-4xl font-light text-gray-700 mb-8">Upcoming Events</h2>
                <div className="flex justify-end mb-4">
                    <button onClick={() => { setFormData({eventid: null}); setIsModalOpen(true); }} className="bg-[#032167] text-white px-5 py-2 rounded text-xs font-semibold flex items-center gap-2">
                        <FaPlus size={10} /> Add Events
                    </button>
                </div>
                <div className="hidden md:block">

                <TableContainer
                    columns={['Event Name', 'Date', 'Time', 'Venue', 'Action']}
                    data={filteredEvents}
                    loading={loading}
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    renderRow={(e, i, srNo) => (
                        <tr key={e.eventid} className="border-b text-center text-xs">
                            <td className="p-3 border-r font-bold text-gray-500">{srNo}</td>
                            <td className="p-3 border-r text-left font-semibold">{e.eventname}</td>
                            <td className="p-3 border-r">{formatDate(e.fromdate)} to {formatDate(e.todate)}</td>
                            <td className="p-3 border-r">{e.frmtime} to {e.totime}</td>
                             <td className="p-3 border-r text-gray-600">{e.venue}</td>

                            <td className="p-3 border-r flex justify-center items-center gap-3">
                                <button onClick={() => handleEdit(e)} className="text-[#64a106]">
                                    <FaEdit />
                                </button>
                                
                                
                                <div className="w-[1px] h-4 bg-gray-300"></div>
                                
                                <button onClick={() => handleDelete(e.eventid)} className="text-gray-600">
                                    <FaTrash />
                                </button>
                            </td>
                        </tr>
                    )}
                />
                </div>
                <div className="md:hidden mt-4">

                <input
                type="text"
                value={searchQuery}
                onChange={(e)=>setSearchQuery(e.target.value)}
                placeholder="Search Events..."
                className="
                w-full
                rounded-xl
                border
                border-gray-300
                p-3
                text-sm
                outline-none
                focus:border-blue-500
                "
                />

                </div>

                <div className="md:hidden mt-4 space-y-4">

                {
                loadingCards ?

                <div className="text-center py-10">

                Loading...

                </div>

                :

                list.length===0 ?

                <div className="text-center py-10">

                No Events

                </div>

                :

                list.map((e)=>(

                <div
                key={e.eventid}
                className="
                bg-white
                rounded-xl
                shadow
                border
                p-4
                "
                >

                <div className="space-y-3">

                <div>

                <p className="text-xs text-gray-500">

                Event

                </p>

                <p className="font-semibold">

                {e.eventname}

                </p>

                </div>

                <div>

                <p className="text-xs text-gray-500">

                Date

                </p>

                <p>

                {formatDate(e.fromdate)}

                -

                {formatDate(e.todate)}

                </p>

                </div>

                <div>

                <p className="text-xs text-gray-500">

                Time

                </p>

                <p>

                {e.frmtime}

                -

                {e.totime}

                </p>

                </div>

                <div>

                <p className="text-xs text-gray-500">

                Venue

                </p>

                <p>

                {e.venue}

                </p>

                </div>

                <div>

                <p className="text-xs text-gray-500">

                Fees

                </p>

                <p>

                {e.fees}

                </p>

                </div>

                <div className="flex justify-end gap-5 pt-2">

                <button
                onClick={()=>handleEdit(e)}
                className="text-green-700"
                >

                <FaEdit/>

                </button>

                <button
                onClick={()=>handleDelete(e.eventid)}
                className="text-red-500"
                >

                <FaTrash/>

                </button>

                </div>

                </div>

                </div>

                ))

                }

                </div>
                <div className="md:hidden flex justify-between items-center py-5">

                <button
                disabled={mobilePage===1}
                onClick={()=>setMobilePage(p=>p-1)}
                className="
                px-4
                py-2
                border
                rounded
                disabled:opacity-40
                "
                >

                Previous

                </button>

                <span>

                Page {mobilePage}

                of

                {mobileTotalPages}

                </span>

                <button
                disabled={mobilePage===mobileTotalPages}
                onClick={()=>setMobilePage(p=>p+1)}
                className="
                px-4
                py-2
                border
                rounded
                disabled:opacity-40
                "
                >

                Next

                </button>

                </div>
            </div>

            {isModalOpen && (
                <div
                    className="
                    fixed
                    inset-0
                    z-[6000]
                    bg-black/60
                    overflow-y-auto
                    "
                >
                    <div
                        className="
                        min-h-screen
                        flex
                        items-start
                        md:items-center
                        justify-center
                        p-3
                        md:p-6
                        "
                    >
                        <div
                            className="
                            bg-white
                            w-full
                            max-w-2xl
                            rounded-xl
                            shadow-2xl
                            mt-10
                            md:mt-0
                            mb-6
                            "
                        >
                            {/* Header */}
                            <div className="flex justify-between items-center border-b px-5 py-4">
                                <h2 className="text-base md:text-xl font-bold">
                                    {formData.eventid ? "Edit Event" : "Add Event"}
                                </h2>

                                <button
                                    onClick={() => setIsModalOpen(false)}
                                    className="text-2xl font-bold text-gray-500 hover:text-red-500"
                                >
                                    ×
                                </button>
                            </div>

                            {/* Body */}
                            <div
                                className="
                                p-4
                                md:p-6
                                max-h-[70vh]
                                overflow-y-auto
                                "
                            >
                                <div
                                    className="
                                    grid
                                    grid-cols-1
                                    md:grid-cols-2
                                    gap-4
                                    "
                                >
                                    <input
                                        value={formData.eventname}
                                        placeholder="Event Name"
                                        className="md:col-span-2 border rounded-lg p-3"
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                eventname: e.target.value,
                                            })
                                        }
                                    />

                                    <input
                                        type="date"
                                        className="border rounded-lg p-3"
                                        value={formData.fromdate}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                fromdate: e.target.value,
                                            })
                                        }
                                    />

                                    <input
                                        type="date"
                                        className="border rounded-lg p-3"
                                        value={formData.todate}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                todate: e.target.value,
                                            })
                                        }
                                    />

                                    <input
                                        type="time"
                                        className="border rounded-lg p-3"
                                        value={formData.frmtime}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                frmtime: e.target.value,
                                            })
                                        }
                                    />

                                    <input
                                        type="time"
                                        className="border rounded-lg p-3"
                                        value={formData.totime}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                totime: e.target.value,
                                            })
                                        }
                                    />

                                    <input
                                        value={formData.venue}
                                        placeholder="Venue"
                                        className="border rounded-lg p-3"
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                venue: e.target.value,
                                            })
                                        }
                                    />

                                    <input
                                        value={formData.fees}
                                        placeholder="Fees"
                                        className="border rounded-lg p-3"
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                fees: e.target.value,
                                            })
                                        }
                                    />

                                    <textarea
                                        rows={4}
                                        value={formData.descrption}
                                        placeholder="Description"
                                        className="md:col-span-2 border rounded-lg p-3 resize-none"
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                descrption: e.target.value,
                                            })
                                        }
                                    />
                                </div>
                            </div>

                            {/* Footer */}
                            <div className="border-t p-4 md:p-5">
                                <button
                                    onClick={handleSave}
                                    className="
                                    w-full
                                    bg-[#032167]
                                    text-white
                                    py-3
                                    rounded-lg
                                    font-bold
                                    hover:bg-blue-900
                                    "
                                >
                                    SAVE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
export default UpcomingEvents;